import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { AnalyticsGranularity } from "../../../api/analyticsAdmin";
import { BumpChart } from "../../../helpers/searchTrending";
import { formatBucketTick } from "../../../helpers/searchTrend";

const TrendingBumpChart: React.FC<{
  chart: BumpChart;
  granularity: AnalyticsGranularity;
  topN: number;
}> = ({ chart, granularity, topN }) => (
  <div className="bg-white rounded-lg shadow p-6">
    <div style={{ height: 360 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chart.rows}
          margin={{ top: 5, right: 24, left: 8, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="bucketStart"
            tickFormatter={(v: string) => formatBucketTick(v, granularity)}
          />
          <YAxis reversed domain={[1, topN]} allowDecimals={false} width={28} />
          <Tooltip formatter={(value: number, name: string) => [`#${value}`, name]} />
          <Legend />
          {chart.series.map((s) => (
            <Line
              key={s.key}
              type="monotone"
              dataKey={s.key}
              name={s.label}
              stroke={s.color}
              dot
              connectNulls={false}
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default TrendingBumpChart;
